interface Props {
  className?: string;
}
const SortAscendingIcon: (props: Props) => JSX.Element = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M4.5 10.5L12 3M12 3L19.5 10.5M12 3V21"
        stroke="#1E40AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortAscendingIcon;
